module.exports = __webpack_public_path__ + "static/media/26-1.bc0f0ed9.mp3";